// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './index.vue'
import 'lib-flexible'
import VueRouter from 'vue-router'
import Index from './components/index.vue'
import Info from './components/info.vue'
import All from './components/all.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
let options = {
  fullscreenEl: false
  // closeEl: false, //控制是否显示右上角关闭按钮
  // tapToClose: true, //点击滑动区域应关闭图库
  // shareEl: false, //控制是否显示分享按钮
  // zoomEl: false, //控制是否显示放大缩小按钮
  // counterEl: false, //控制是否显示左上角图片数量按钮
  // arrowEl: true,  //控制如图的左右箭头（pc浏览器模拟手机时）
  // tapToToggleControls: true, //点击应切换控件的可见性
  // clickToCloseNonZoomable: true //点击图片应关闭图库，仅当图像小于视口的大小时
};
Vue.use(preview,options)
// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'

// Vue.use(Viewer)
// Viewer.setDefaults({
//   Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
// })
Vue.use(VueRouter,Mint)
import { Swipe, SwipeItem } from 'mint-ui';

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.prototype.$axios = axios

const router = new VueRouter({
  routes: [
    // 动态路径参数 以冒号开头
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/info',
      name: 'info',
      component: Info
    },
    {
      path: '/all',
      name: 'all',
      component: All
    }

  ]
})


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/pages/index/index.js